import { createContext, useContext, type ReactNode } from "react";

export type DesktopShellEngine = "circle" | "compass";

export const CIRCLE_V4_DESKTOP_SHELL_FLAG =
  "circle_v4_desktop_shell_enabled" as const;

const DesktopShellEngineContext = createContext<DesktopShellEngine>("circle");
DesktopShellEngineContext.displayName = "DesktopShellEngineContext";

interface DesktopShellEngineProviderProps {
  children: ReactNode;
  engine: DesktopShellEngine;
}

export const DesktopShellEngineProvider = ({
  children,
  engine,
}: DesktopShellEngineProviderProps) => (
  <DesktopShellEngineContext.Provider value={engine}>
    {children}
  </DesktopShellEngineContext.Provider>
);

export const useDesktopShellEngine = (): DesktopShellEngine =>
  useContext(DesktopShellEngineContext);
